export namespace EposFiscalDevice {
    export const TNT = 999;
    export const TCL = 12;
    export const TENTER = 0x0d;

    export type EventType = 'device_data' | 'close_device' | 'open_device';

    export type ConnectionStatus = 'connecting' | 'connected' | 'disconnected' | 'error';

    export interface ConnectionState {
        ip: string;
        status: ConnectionStatus;
        error?: string;
    }

    export type DeviceDataPayload = {
        type: 'ondata' | 'onerror';
        data1: number;
        data2: number;
        data3: number;
        data4: number;
    }

    export const scanCodeLowerCaseTable = [
        TNT, TNT, '1', '2', '3', '4', '5', '6', '7', '8', // 00
        '9', '0', '\'', TNT, TNT, TNT, 'q', 'w', 'e', 'r', // 10
        't', 'y', 'u', 'i', 'o', 'p', TNT, '*', TENTER, TNT, // 20
        'a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l', '@', // 30
        TNT, TNT, TNT, '>', 'z', 'x', 'c', 'v', 'b', 'n', // 40
        'm', ';', '.', '-', TNT, '*', TNT, ' ', TNT, TNT, // 50
        TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, // 60
        TNT, '7', '8', '9', '-', '4', '5', '6', '+', '1', // 70
        '2', '3', '0', '.', TNT, TNT, TNT, TNT, TNT, TNT, // 80
        TNT, TNT, TNT, TNT, TNT, TNT, TENTER, TNT, TNT, TNT, // 90
        TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, //100
        TNT, TCL, TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, //110
        TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, //120
        TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, //130
        TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, //140
        TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, //150
        TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, //160
        TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, //170
        TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, //180
        TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, //190
        TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, //200
        TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, //210
        TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, //220
        TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, //230
        TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, //240
        TNT, TNT, TNT, TNT, TNT, TNT, //250
    ];

    export const scanCodeUpperCaseTable = [
        TNT, TNT, '!', '"', '#', '$', '%', '&', '/', '(', // 00
        ')', '=', '?', TNT, TNT, TNT, 'Q', 'W', 'E', 'R', // 10
        'T', 'Y', 'U', 'I', 'O', 'P', TNT, '+', TENTER, TNT, // 20
        'A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L', '@', // 30
        TNT, TNT, TNT, '<', 'Z', 'X', 'C', 'V', 'B', 'N', // 40
        'M', ',', ':', '_', TNT, '*', TNT, ' ', TNT, TNT, // 50
        TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, // 60
        TNT, '7', '8', '9', '-', '4', '5', '6', '+', '1', // 70
        '2', '3', '0', '.', TNT, TNT, TNT, TNT, TNT, TNT, // 80
        TNT, TNT, TNT, TNT, TNT, TNT, TENTER, TNT, TNT, TNT, // 90
        TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, //100
        TNT, TCL, TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, //110
        TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, //120
        TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, //130
        TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, //140
        TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, //150
        TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, //160
        TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, //170
        TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, //180
        TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, //190
        TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, //200
        TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, //210
        TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, //220
        TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, //230
        TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, TNT, //240
        TNT, TNT, TNT, TNT, TNT, TNT, //250
    ];
}